import React from 'react';

import Icon from 'Components/Icon';
import DropdownMenu from 'Components/Admin/DropdownMenu';

function ExportBtn() {
  return (
    <div>
      <DropdownMenu triggerButtonRender={() => <Icon className="icon-export" />} binding="bottom">
        <li>
          <button>
            <span>PDF</span>
          </button>
        </li>
        <li>
          <button>
            <span>DOCX</span>
          </button>
        </li>
        <li>
          <button>
            <span>TIFF</span>
          </button>
        </li>
        <li>
          <button>
            <span>HTML</span>
          </button>
        </li>
      </DropdownMenu>
    </div>
  );
}

export default ExportBtn;
